// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3fyy0","inputWrap":"CustomTip_inputWrap__3vaow"};